import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const RouteTitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const pathToTitleMap: Record<string, string> = {
      "/": "Personal Protective Equipment in Bulk | PPE.us",
      "/covid-19-test-kits.html":
        "Onsite & At-home COVID-19 Test Kits in Bulk| PPE.us | PPE.us",
      "/nitrile-gloves.html": "Nitrile Gloves in Bulk | PPE.us",
      "/disposable-masks.html":
        "Disposable Face Masks in Bulk | PPE.us | PPE.us",
      "/surface-wipes.html": "Disinfectant Wipes in Bulk | PPE.us | PPE.us",
      "/hand-sanitizer": "Hand Sanitizer in Bulk | PPE.us | PPE.us",
      "/about-us": "About Us | PPE.us",
      "/contact": "Contact Us | PPE.us",
      "/privacy-policy": "Privacy Policy | PPE.us",
      "/frequently-asked-questions": "Frequently Asked Questions | PPE.us",
      "/terms-of-use":
        "Terms of Use | iPromo – Custom Promotional Products | PPE.us",
      "/terms-of-sales": "Terms Of Sales | PPE.us",
    };

    const currentPath = location.pathname;
    const pageTitle = pathToTitleMap[currentPath] || "My App";

    document.title = pageTitle;
  }, [location.pathname]);

  return null;
};
